import { render } from "./ChangeStatusDialog.vue?vue&type=template&id=256b63de"
import script from "./ChangeStatusDialog.vue?vue&type=script&lang=js"
export * from "./ChangeStatusDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__